import { render, staticRenderFns } from "./spinner-vue.vue?vue&type=template&id=2f4bca8b&scoped=true&"
import script from "./spinner-vue.vue?vue&type=script&lang=js&"
export * from "./spinner-vue.vue?vue&type=script&lang=js&"
import style0 from "./spinner-vue.vue?vue&type=style&index=0&id=2f4bca8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4bca8b",
  null
  
)

export default component.exports